import * as React from "react";

function SvgRetwitte(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="Retwitte_svg__r-4qtqp9 Retwitte_svg__r-yyyyoo Retwitte_svg__r-1xvli5t Retwitte_svg__r-dnmrzs Retwitte_svg__r-bnwqim Retwitte_svg__r-1plcrui Retwitte_svg__r-lrvibr Retwitte_svg__r-1hdv0qi"
      width="0.8em"
      height="0.8em"
      {...props}
    >
      <path d="M23.77 15.67a.749.749 0 00-1.06 0l-2.22 2.22V7.65a3.755 3.755 0 00-3.75-3.75h-5.85a.75.75 0 000 1.5h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22a.749.749 0 10-1.06 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5a.747.747 0 000-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22a.752.752 0 001.062 0 .749.749 0 000-1.06l-3.5-3.5a.747.747 0 00-1.06 0l-3.5 3.5a.749.749 0 101.06 1.06l2.22-2.22V16.7a3.755 3.755 0 003.75 3.75h5.85a.75.75 0 000-1.5z" />
    </svg>
  );
}

export default SvgRetwitte;
